import { TooltipedTextComponent } from 'commons/components';
import { sortAndJoin } from 'commons/utils/sort.utils';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n';
import { CustomAlarmListItem } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/settings-devices-custom-alarm-list.model';
import { getCustomAlarmDeletionTexts } from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-list/components/custom-alarm-deletion-confirmation-modal/custom-alarm-deletion-confirmation-modal.business';
import React from 'react';

export interface CustomAlarmDeletionConfirmationModalHeaderComponentProps {
    alarmDefinitions: CustomAlarmListItem[];
}

export const CustomAlarmDeletionConfirmationModalHeaderComponent: React.FC<
    CustomAlarmDeletionConfirmationModalHeaderComponentProps
> = ({ alarmDefinitions }) => {
    const { t } = useTranslation();
    const texts = getCustomAlarmDeletionTexts(alarmDefinitions);

    if (alarmDefinitions.length === 1) {
        return <PocTypography variant="button">{t(texts.headerText)}</PocTypography>;
    }

    return (
        <TooltipedTextComponent
            i18nKey={texts.headerText}
            tooltipText={sortAndJoin(alarmDefinitions.map((definition) => definition.notificationName))}
            i18nValues={{ amount: alarmDefinitions.length }}
            tooltipAnchorClassname="blue-tooltip-span"
            showTooltipAlways
        />
    );
};
